import { render, staticRenderFns } from "./InspirationList.vue?vue&type=template&id=b388402c"
import script from "./InspirationList.vue?vue&type=script&lang=js"
export * from "./InspirationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports